import React, { Fragment, useState, useEffect } from 'react';
import Modal from '../../../SensorSelect/common/Modal/Modal';
import './ExploreTabs.scss';
import Scroll from '../../../../partials/Scroll/Scroll';
import VideoWrapper from '../../../ModesOfOperation/partials/VideoWrapper/VideoWrapper';
import Button from '../../../../partials/Button'
import TabNavigation from '../../../../partials/TabsContainer/TabNavigation';
import Media from '../../../../partials/Media';
import ExploreQuestions from '../ExploreQuestions/ExploreQuestions';

const ExploreTabs = props => {
  
  const { data, source, currentTab, changeTab, changeSubTab, changeScore, score, questionOptions, handleComplete, tabViewed} = props;
  // This is only for showing the tab controls when its needed
  const [visibleTabs, setVisibleTabs] = useState(0);
  const [modalVisibility, setModalVisibility] = useState(false);
  const [ modalData, setModalData ] = useState({
    header: 'Header here',
    body: 'content of the modal',
    button: 'Next',
    onClose: () => { } 
  });
  const [ closebuttonstate, setClosebuttonstate ] = useState(false);
  const [ videoVisible, setVideoVisible ] = useState(false);
  const [hasQuestions, setHasQuestions] = useState(false);


  const checkVisibleTabs = () => {
    let visible = 0;
    data.tabs.map((tab) => {
      if (tab.visible) {
        visible += 1;
      }
    });
    // console.log(visible);
    setVisibleTabs(visible);
  };

  const showModal = video => {
    // {console.log(video,"video")}
    setModalData({
      header: video.title,
      body: <VideoWrapper {...video} visible={true} setClosebuttonstate={setClosebuttonstate} />,
      button: 'Close',
      closebuttonstate: closebuttonstate,
      onClose: () => { clearModal() },
      size: 'lg'
    });
    // {console.log(modalData,"modalData")}
    setVideoVisible(true);
    setModalVisibility(true);
    // {console.log(modalVisibility,"modalVisibility")}

  };

  const clearModal = () => {
    setModalVisibility(false);
    setModalData({});
    setClosebuttonstate(false);
  }

  const handleScroll = (direction = 'right') => {
    const element = document.getElementById("nav-tabs-container");
    const width = element.offsetWidth;
    const scrollWidth = element.scrollWidth;
    const currentScroll = element.scrollLeft;

    let scrollAmount = 0;
    if (direction === 'left') {
      scrollAmount = currentScroll - ((width / data.options.visibleTabs) * data.options.scrollBy);
    } else {
      scrollAmount = currentScroll + ((width / data.options.visibleTabs) * data.options.scrollBy);
    }

    element.scrollTo({
      left: scrollAmount,
      behavior: 'smooth'
    });

  };
  if(props.currentTab==1){
    if(props.tabCss=='global_button_single'){
    props.setTabCss('global_button_two');
  }
  }
  // If we dont have questions the next button should be enabled
  const checkIfHasQuestions = () => {
    let result = data.tabs.filter(tab => tab.questions.length > 0).length > 0
    setHasQuestions(result)
  }

  useEffect(() => {
    checkVisibleTabs();
  }, [data])

  useEffect(() => {
    checkIfHasQuestions()
  }, [])

  return (
    <div className="explore-tabs">
      <div className="multitabs-root">
        <div className="nav-tabs-container">
          <div className="tabs" id="nav-tabs-container">
          <TabNavigation 
            data={ data.tabs.map((tabItem) => ( {...tabItem, name: tabItem.title } )) } 
              selected = {currentTab}
              onSelectHandle={ (selectedTabItem, itemIndex) => { changeTab(itemIndex) } } 
            />
        </div>
        </div>
      </div>
      <div className="tab-content">
        <div className="subtab-wrapper">
          <Scroll>
          <ul className="subtab-list">
            {
              data.tabs[currentTab].subTabs.map((subTab, subTabIndex) => (
                <li key={`subtab-item-${subTabIndex}}`}
                  className={`subtab-item ${subTab.active ? 'active' : ''}`}
                  onClick={() => { changeSubTab(subTabIndex) }}>
                  {subTab.title}
                </li>
              ))
            }
          </ul>
          </Scroll>
          <div className="subtab-body">
          <Scroll> 
            <div className="subtab-body-height">
            {
              data.tabs[currentTab].subTabs.map((subTab, subTabIndex) => (
                subTab.active &&
                <Fragment key={`subtab-body-element-${subTabIndex}}`}>
                  <div dangerouslySetInnerHTML={{ __html: subTab.body }}></div>
                  {
                    subTab.images.length > 0 &&
                    <div className="image-list">
                      {
                        subTab.images.map((image, imageIndex) => (
                          <div className="image-item" key={`image-item-${imageIndex}`}>
                            <Media src={image.url} alt={image.alt}/>
                          </div>
                        ))
                      }
                    </div>
                  }
                  {
                    subTab.audios.length > 0 &&
                    <div className="audio-list">
                      {
                        subTab.audios.map((audio, audioIndex) => (
                          <div className="audio-item" key={`audio-item-${audioIndex}`}>
                            <audio controls width="100%">
                              <source src={audio.url} type={`audio/${audio.extension}`} />
                            </audio>
                          </div>
                        ))
                      }
                    </div>
                  }
                  {
                    subTab.videos.length > 0 &&
                    <div className="video-list">
                      {
                        subTab.videos.map((video, videoIndex) => (
                          <div className="video-item" key={`video-item-${videoIndex}`}>
                            {video.showInPopup ?
                              <>
                                {/* <img src={video.thumbnail} alt={subTab.title} />
                                <div className="play-indicator"
                                  onClick={() => {showModal(video)
                                  //   props.showModal({
                                  //     title: video.title,
                                  //     body: (
                                  //       <video width="100%" controls id="video-player" autoPlay={video.autoPlay}>
                                  //         <source src={video.url} type="video/mp4" />
                                  //         Your browser does not support the video tag.
                                  //       </video>
                                  //     )
                                  //   });
                                  }
                                  }></div> */}
                                  <video width="100%" controls id="video-player" autoPlay={video.autoPlay}>
                                  //         <source src={video.url} type="video/mp4" />
                                  //         Your browser does not support the video tag.
                                  //       </video>
                              </>
                              :
                              <video width="100%" controls id="video-player" autoPlay={video.autoPlay}>
                                <source src={video.url} type="video/mp4" />
                                Your browser does not support the video tag.
                              </video>
                            }
                          </div>
                        ))
                      }
                    </div>
                  }
                </Fragment>
              ))
            }
            </div>
            </Scroll> 
          </div>
        </div>
          <div className="questions">
            {hasQuestions && score < 99 ?
              <ExploreQuestions
                data={data}
                currentTab={currentTab}
                changeTab={changeTab}
                changeScore={changeScore}
              />
              :
              <div className="quiz-completed">
                {questionOptions.hasOwnProperty("onCompleteMessage") &&
                  <Scroll> 
                  <div dangerouslySetInnerHTML={{ __html: questionOptions.onCompleteMessage }} className="on-complete-message"></div>
                  </Scroll>
                }
                {/* <div className="completed-actions">
                  <Button
                    text="Next"
                    onClick={handleComplete}
                  />
                </div> */}
              </div>
            }

          </div>
       
      
      </div>
      <div className="completed-actions">
                  <Button
                    text="Next"
                    onClick={handleComplete}
                    disabled={hasQuestions && score !== 100}
                  />
                </div>   
      { modalVisibility &&
        <Modal show={modalVisibility}
        showContinue={false}
        size={'large'}
>
        <div> <Button text="close" onClick={()=>setModalVisibility(false)}></Button></div>
      </Modal>
      // <div style={{color:"white"}}>TEST VISIBLITY</div>
      }
    </div>
  );

};

export default ExploreTabs;